import TwoColumnLayout from '../layouts/TwoColumnLayout'
import Sidebar from "../components/leftContent/Sidebar";

export default function Root({rightContent, icon}) {
    return (
        <TwoColumnLayout leftContent={<Sidebar/>} rightContent={rightContent} icon={icon} key={rightContent}/>
    )
}

